import React from 'react';

const RightTrack = () => {
    return (
        <div className="row left-img dots-right">
            <div className="col-md-6">
                <img src="https://imagedelivery.net/kzmnnJ873EMh0gbgIGnXTA/7e0d08e8-5078-4f80-b4ab-2b0326c8dd00/public" alt="" aria-hidden="true" />
            </div>
            <div className="col-md-6">
                <h3>We are on the right track&mdash;but we're not done.</h3>

                <p className="p3">Gov. Kathy Hochul and the New York State Legislature made a historic investment in transit service as part of the 2023 New York state budget, recognizing the essential nature of transit service to millions of New York residents and businesses.</p>
                
                <p className="p3">But operating the service is only half the picture&mdash;building and rebuilding stations, tunnels, signals, elevators, electric buses, rail yards, bus depots, and other infrastructure is also critical.</p>
                
                <p className="p3"><a className="plus-sign blue" href='documents/Intro_VastSystem.pdf' target="_blank" rel="noreferrer">Our system is vast&mdash;and has a lot of needs</a></p>
            
                <p className="p3">The recent $55 billion 2020-2024 Capital Program acknowledged the scale of the task ahead. But there is a lot of work still to be done.</p>
            </div>
        </div>
    );
}

export default RightTrack;